import { render } from "./PlayerShared.vue?vue&type=template&id=4b25e4d7"
import script from "./PlayerShared.vue?vue&type=script&lang=js"
export * from "./PlayerShared.vue?vue&type=script&lang=js"

import "./PlayerShared.vue?vue&type=style&index=0&id=4b25e4d7&lang=css"
script.render = render

export default script